import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button, Drawer, Spin } from "antd";

class UIDrawerForm extends Component {
	static propTypes = {
		visible           : PropTypes.bool.isRequired,
		onClose           : PropTypes.func.isRequired,
		formId            : PropTypes.any,
		isLoading         : PropTypes.bool,
		isSending         : PropTypes.bool,
		width             : PropTypes.any,
		icon              : PropTypes.node,
		title             : PropTypes.any,
		subtitle          : PropTypes.any,
		steps             : PropTypes.node,
		extra             : PropTypes.node,
		footer            : PropTypes.node,
		showBtnSave       : PropTypes.bool,
		btnSaveText       : PropTypes.any,
		btnSaveTextSending: PropTypes.any,
		drawerProps       : PropTypes.object,
		disabledBtn		  : PropTypes.bool,
	};

	static defaultProps = {
		isLoading         : false,
		isSending         : false,
		disabledBtn 	  : false,
		width             : 500,
		icon              : null,
		title             : "",
		subtitle          : "",
		steps             : null,
		extra             : null,
		footer            : null,
		showBtnSave       : true,
		btnSaveText       : "Salvar",
		btnSaveTextSending: "Salvando",
		drawerProps       : {},
	};

	render() {
		const {visible, formId, isLoading, isSending, width, icon, title, subtitle, steps, extra, footer, showBtnSave, btnSaveTextSending, btnSaveText, drawerProps, disabledBtn} = this.props;

		return (
			<Drawer
				open={visible}
				className="drawer-form"
				width={width}
				destroyOnClose={true}
				maskClosable={!isLoading && !isSending}
				closable={false}
				keyboard={!isLoading && !isSending}
				placement="right"
				onClose={this.props.onClose}
				{...drawerProps}>
				<div className="drawer-form-inner">
					<div className={`drawer-form-header ${subtitle ? "has-subtitle" : ""} ${icon ? "has-icon" : ""} ${steps ? "has-steps" : ""}`}>
						<div className="drawer-form-header-top">
							<Button className="btn-close" onClick={this.props.onClose} icon={<i className="far fa-times" />} disabled={disabledBtn || isLoading || isSending} />
							{icon && <div className="drawer-form-title-icon">{icon}</div>}
							<div className="ant-drawer-title">
								<div className="ant-drawer-title-text">{title}</div>
								{subtitle && <div className="ant-drawer-title-subtitle">{subtitle}</div>}
							</div>
							{extra && !isLoading && <div className="drawer-form-header-extra">{extra}</div>}
							{showBtnSave && <Button type="primary" form={formId} htmlType="submit" className="btn-save" icon={<i className="far fa-check" />} loading={isSending} disabled={disabledBtn || isLoading}>{isSending ? btnSaveTextSending : btnSaveText}</Button>}
						</div>
						{steps && <div className="drawer-form-header-steps">{steps}</div>}
					</div>
					<div className="drawer-form-body">
						{isLoading ? (
							<div className="text-center" style={{padding: 20}}>
								<Spin indicator={<i className="fad fa-spinner-third fa-spin fa-3x" />} />
							</div>
						) : (
							<div className="drawer-form-body-inner">
								{this.props.children}
							</div>
						)}
					</div>
					{footer && !isLoading && <div className="drawer-form-footer">{footer}</div>}
				</div>
			</Drawer>
		)
	}
}

export default UIDrawerForm;
